import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, toHandlers as _toHandlers, mergeProps as _mergeProps, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-125a6a0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "uk-margin-top" }
const _hoisted_2 = { class: "uk-margin-top" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 1,
  class: "uk-float-right"
}
const _hoisted_5 = {
  key: 2,
  class: "uk-float-right"
}
const _hoisted_6 = {
  key: 3,
  class: "uk-float-right uk-text-danger"
}
const _hoisted_7 = { class: "uk-margin-top check-container" }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  class: "uk-form"
}
const _hoisted_10 = { class: "uk-form-icon search-container" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "uk-icon-search" }, null, -1))
const _hoisted_12 = {
  key: 1,
  class: "items"
}
const _hoisted_13 = { key: 0 }
const _hoisted_14 = {
  key: 0,
  class: "uk-margin-small-top"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("small", null, "Add New Data", -1))
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = {
  key: 1,
  class: "success-info"
}
const _hoisted_18 = {
  key: 1,
  class: "uk-grid uk-margin-small-top"
}
const _hoisted_19 = { class: "uk-width-3-4" }
const _hoisted_20 = { class: "uk-width-1-4 uk-padding-remove-left" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Input = _resolveComponent("Input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.title)
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.title), 1))
        : _createCommentVNode("", true),
      (_ctx.disableHighlightingCount && !_ctx.selectedCount)
        ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(_ctx.selectedCount) + " selected", 1))
        : (_ctx.selectedCount)
          ? (_openBlock(), _createElementBlock("b", _hoisted_5, _toDisplayString(_ctx.selectedCount) + " selected", 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(_ctx.selectedCount) + " selected", 1))
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("div", _mergeProps({
        class: ["head", { 'header-cursor': _ctx.widerSelectionBox }]
      }, _toHandlers(
                    _ctx.widerSelectionBox ? { click: () => (_ctx.opened = !_ctx.opened) } : {}
                , true)), [
        (_ctx.selectAll)
          ? (_openBlock(), _createBlock(_component_Checkbox, {
              key: 0,
              click: _ctx.toggleCheckAll,
              label: 
                        _ctx.header + ' (' + _ctx.selectedCount + '/' + _ctx.totalCount + ')'
                    ,
              partial: !!_ctx.partialChecked,
              checked: _ctx.partialChecked || _ctx.allChecked
            }, null, 8, ["click", "label", "partial", "checked"]))
          : (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("span", null, _toDisplayString(_ctx.header) + " (" + _toDisplayString(_ctx.selectedCount) + "/" + _toDisplayString(_ctx.totalCount) + ")", 1),
              _createElementVNode("i", _mergeProps({
                class: ["uk-float-right toggle-opened", {
                            'uk-icon-caret-right': !_ctx.opened,
                            'uk-icon-caret-down': _ctx.opened,
                        }]
              }, _toHandlers(
                            !_ctx.widerSelectionBox
                                ? { click: () => (_ctx.opened = !_ctx.opened) }
                                : {}
                        , true)), null, 16)
            ]))
      ], 16),
      (_ctx.opened && _ctx.hasSearchBar)
        ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _withDirectives(_createElementVNode("input", {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
                type: "text",
                placeholder: "Search",
                class: "search-input"
              }, null, 512), [
                [_vModelText, _ctx.searchText]
              ]),
              _hoisted_11
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.opened)
        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getSortedOptions, (name, id) => {
              return (_openBlock(), _createElementBlock("div", {
                key: id,
                class: "item"
              }, [
                _createVNode(_component_Checkbox, {
                  id: id,
                  label: _ctx.getOptionLabel(name),
                  checked: _ctx.shouldCheck(id),
                  click: _ctx.toggleCheck
                }, null, 8, ["id", "label", "checked", "click"])
              ]))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ]),
    (_ctx.add)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
          (!_ctx.adding)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (!_ctx.newDataAdded)
                  ? (_openBlock(), _createElementBlock("a", {
                      key: 0,
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.adding = true))
                    }, _hoisted_16))
                  : (_openBlock(), _createElementBlock("small", _hoisted_17, "New Data Added Successfully!"))
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_Input, {
                    ref: "newDataInput",
                    modelValue: _ctx.newData,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newData) = $event)),
                    title: 'New ' + _ctx.header + ' Name',
                    placeholder: 'New ' + _ctx.header + ' Name',
                    required: true,
                    regex: _ctx.regex,
                    "err-msg": 'Invalid New ' + _ctx.header + ' Name'
                  }, null, 8, ["modelValue", "title", "placeholder", "regex", "err-msg"])
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _createElementVNode("button", {
                    class: "uk-button btn-add",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.onAddData && _ctx.onAddData(...args)))
                  }, " Add ")
                ])
              ]))
        ]))
      : _createCommentVNode("", true)
  ]))
}